import React from 'react';
import { Modal, Button, List } from 'antd';
import translations from '../core/data/disaster-translations.json';
import { getImageUrl } from '../core/images';

const Prediction = ({ isOpen, regionName, prediction, onClose }) => {
  console.log(prediction)
  return (
    <Modal
      title={regionName}
      open={isOpen}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          OK
        </Button>,
      ]}
    >
      La probabilidad de desastre en la región {regionName}:
      <List
        itemLayout='horizontal'
        dataSource={prediction}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              avatar={<img src={getImageUrl(item.label)} alt={translations[item.label] || item.label} style={{ width: 50, height: 50 }} />}
              title={translations[item.label] || item.label}
              description={Math.floor(item.probability * 100) + '%'}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default Prediction;
